module.exports = __webpack_public_path__ + "common/sidebar/icon-category-0b5c5f6c828f469d8e79908a8e986cb0.svg";